import styled from "styled-components"

export const BannerContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.2rem 1.6rem;
  margin: 0 0 2rem;
  border-radius: 0.6rem;
  background: ${(p) => p.theme.colors.errorBackground};
  border: 0.1rem solid ${(p) => p.theme.colors.errorBorder};
  color: ${(p) => p.theme.colors.errorText};

  > svg {
    min-width: 2rem;
    max-width: 2rem;
    margin-top: 0.2rem;
    fill: ${(p) => p.theme.colors.errorText};
  }
`

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`

export const BannerTitle = styled.div`
  font-weight: 700;
  font-size: 1.3rem;
`

export const BlockedList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: 0.4rem;
`

export const BlockedOperation = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.2rem 0.8rem;
  border-radius: 0.4rem;
  background: rgba(255, 255, 255, 0.3);
  border: 0.1rem solid rgba(204, 51, 51, 0.1);
  font-size: 1.1rem;
  font-weight: 600;

  svg {
    width: 1rem;
    height: 1rem;
    fill: ${(p) => p.theme.colors.errorText};
  }
`

export const StateDescription = styled.span`
  font-size: 1.2rem;
  font-style: italic;
`

export const BannerHint = styled.span`
  font-size: 1.1rem;
  font-style: italic;
  opacity: 0.8;
`
